import * as Yup from "yup";

export const areaSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Nome da área muito curto")
        .required("O nome da área é obrigatório"),
    photoUrl: Yup.string().nullable(),
    width: Yup.number().typeError("Largura deve ser um número").positive("A largura deve ser maior que zero").required("Largura é obrigatória"),
    length: Yup.number().typeError("Comprimento deve ser um número").positive("O comprimento deve ser maior que zero").required("Comprimento é obrigatório"),
    status: Yup.string().oneOf(["active", "inactive"]).default("active"),
});
